<template>
  <v-sheet class="pa-2 sidebar-container">
    <v-list-item
      :title="$t('labels.selected-entity')"
      class="text-h6"
    ></v-list-item>

    <v-divider class="my-2" />

    <v-text-field
      v-model="search"
      :label="$t('labels.search')"
      prepend-inner-icon="mdi-magnify"
      density="compact"
      variant="outlined"
      class="mx-4"
      clearable
    />

    <v-container class="height-sidebar-custom">
      <v-list density="compact" v-if="visibleEntities?.length > 0">
        <SidebarElement
          v-for="(entity, idx) in visibleEntities"
          :key="idx"
          :item="entity"
          @clickElement="clickElement"
        ></SidebarElement>
      </v-list>

      <v-col
        v-if="visibleEntities?.length == 0"
        cols="12"
        class="d-flex flex-column align-center justify-center py-6"
      >
        <v-icon size="36" color="grey">mdi-magnify-close</v-icon>
        <div class="text-grey mt-2">{{ $t("labels.no-results") }}</div>
      </v-col>
    </v-container>
  </v-sheet>
</template>

<script setup>
import { ref, computed, defineEmits } from "vue";
import SidebarElement from "./SidebarElement.vue";

const props = defineProps(["entities"]);

const emit = defineEmits(["clickElement"]);

const search = ref("");

function filterSearchEntities(search) {
  if (!search) {
    return props.entities;
  }

  const searchEntities = [];

  for (let e of props.entities) {
    if (e.data.aliasName.toLowerCase().indexOf(search.toLowerCase()) > -1) {
      searchEntities.push(e);
    }
  }

  return searchEntities;
}

const visibleEntities = computed(() => filterSearchEntities(search.value));

function clickElement(data) {
  emit("clickElement", data);
}
</script>

<style scoped>
.height-tabs-window-custom {
  max-height: calc(100vh - 365px);
  overflow-y: auto;
}

.sidebar-container {
  position: relative;
  overflow: hidden;
  height: 100%;
}
</style>
